import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export const store = new Vuex.Store({
	state: {
	    apidata: [],
	    classBody: false,
	    docHeight: false,
	    issueFilter: false,
	    issueSelected: null,
	    compass: false,
	    selectedVal: false,
	    instruction: true,
	    menuClick: false,
	    previousRoute: false,
	    menuInstruction: false,
	},
	mutations: {
	    SET_DATASET: (state, { list }) => {
		    state.apidata = list
	    }
	},
	actions: {
	    LOAD_DATASET: function ({ commit }) {
			return axios.get('/cms/api/data').then((response) => {
				commit('SET_DATASET', { list: response.data })
				document.dispatchEvent(new Event('render-now'))
			}, (err) => {
				console.log(err)
			})
	    }
	}
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js